import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';
import { Typography } from '@usepepper/ui/atoms/typography';

export interface HubCardBaseProps {
  actionsElement?: React.ReactNode;
  children: React.ReactNode;
  childrenStyle?: StyleProp<ViewStyle>;
  description?: string;
  title: string;
}

export const HubCardBase: React.FC<HubCardBaseProps> = ({
  actionsElement,
  children,
  childrenStyle,
  description,
  title,
}) => {
  const [styles] = useStyles();
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={styles.titleContainer}>
          <View style={styles.margin}>
            <Typography numberOfLines={1} variant="heading-sm">
              {title}
            </Typography>
          </View>
          {description ? (
            <Typography numberOfLines={1} variant="paragraph-md">
              {description}
            </Typography>
          ) : null}
        </View>
        {actionsElement ? (
          <View style={styles.actionsElement}>{actionsElement}</View>
        ) : null}
      </View>
      <View style={[styles.contentContainer, childrenStyle]}>{children}</View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  actionsElement: {
    flex: 3,
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  container: {
    backgroundColor: theme.sk.color.bg.primary.default,
    borderRadius: 12,
    padding: 16,
    width: '100%',
  },
  contentContainer: {
    width: '100%',
  },
  header: {
    flexDirection: 'row',
    gap: 8,
  },
  margin: {
    marginRight: 8,
  },
  titleContainer: {
    flex: 9,
  },
}));
